module.exports = __webpack_public_path__ + "static/media/image8.2df1ad66.png";